<template>
    <div>
        <div class="preview-wraper" v-if="null !== imgWraperStyle" :style="previewWraperStyle">
            <span class="img-wraper" :style="imgWraperStyle">
                <img :src="imgSrc" />
            </span>
        </div>
        <div class="thumb" v-if="null !== thumbTop" @mouseenter="ownerMoved" @mousemove="ownerMoved" @mouseleave="ownerLeaved"
            :style="{width:thumbWidth+'px',height:thumbHeight+'px',top:thumbTop+'px',left:thumbLeft+'px'}"
            ></div>
    </div>
</template>

<script>
export default {
    props:[
        'originalWidth',
        'originalHeight',
        'ratio'
    ],
    data() {
        return {
            thumbWidth: this.originalWidth / this.ratio,
            thumbHeight: this.originalHeight / this.ratio,
            thumbTop: null,
            thumbLeft: null,
            previewWraperStyle: {
                'width': this.originalWidth + 'px',
                'height': this.originalHeight + 'px',
                'left': (parseInt(this.originalWidth) + 10) + 'px'
            },
            imgWraperStyle: null,
            imgSrc: null,
            moved: false
        }
    },
    computed: {
    },
    methods: {
        thumbMoved(e, imgSrc) {
            if (null == imgSrc) {
                return 
            }
            this.moved = false
            this.imgSrc = imgSrc
            let thumbTop = e.offsetY - this.thumbHeight / 2
            let thumbLeft = e.offsetX - this.thumbWidth / 2
            this.moveThumb(thumbTop, thumbLeft)
        },
        thumbLeaved() {
            setTimeout(() => {
                if (this.thumbTop >= 0 && this.moved) {
                    return;
                }
                console.log("thumbLeaved")
                this.ownerLeaved('g');
            }, 0);
        },
        ownerMoved(e) {
            this.moved = true;
            let thumbTop = this.thumbTop + (e.offsetY - this.thumbHeight / 2)
            let thumbLeft = this.thumbLeft + (e.offsetX - this.thumbWidth / 2)
            this.moveThumb(thumbTop, thumbLeft)
        },
        ownerLeaved(f) {
            this.thumbTop = null
            this.imgWraperStyle = null
        },
        moveThumb(thumbTop, thumbLeft) {
            let shake = 1
            if (thumbTop < 0) {
                this.thumbTop = 0
            } else if (thumbTop > this.originalHeight - this.thumbHeight) {
                this.thumbTop = this.originalHeight - this.thumbHeight
            } else if (this.thumbTop >= thumbTop - shake && this.thumbTop <= thumbTop + shake) {
            } else {
                this.thumbTop = thumbTop
            }
            if (thumbLeft < 0) {
                this.thumbLeft = 0
            } else if (thumbLeft > this.originalWidth - this.thumbWidth) {
                this.thumbLeft = this.originalWidth - this.thumbWidth
            }  else if (this.thumbLeft >= thumbLeft - shake && this.thumbLeft <= thumbLeft + shake) {
            } else {
                this.thumbLeft = thumbLeft
            }
            this.moveImgWraper()
        },
        moveImgWraper() {
            this.imgWraperStyle = {
                top : (this.thumbTop * this.ratio * -1) + 'px',
                left : (this.thumbLeft * this.ratio * -1) + 'px'
            }
        }
    }
}
</script>

<style lang="less">
    * {  
	    -webkit-touch-callout:none;  /*系统默认菜单被禁用*/   
	    -webkit-user-select:none; /*webkit浏览器*/   
    	-khtml-user-select:none; /*早期浏览器*/   
	    -moz-user-select:none;/*火狐*/   
	    -ms-user-select:none; /*IE10*/   
	    user-select:none;   
    }
    .preview-wraper {
        // width: 580px;
        // height: 450px;
        position: absolute;
        top: 0;
        // left: 590px;
        z-index: 100;
        border: 1px solid #ccc;
        text-align: center;
        overflow: hidden;
        background: url(data:image/png;base64,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);
        .img-wraper {
            width: 3 * 100%;
            height: 3 * 100%;
            text-align: center;
            display: inline-block;
            position: relative;

            left: -3 * 100px;
            img {
                max-width: none;
                max-height: none;
                vertical-align: middle;
                height: 100%;
            }
        }
    }
    .thumb {
        width: 580px / 3;
        height: 450px / 3;
        position: absolute;
        top: 0;
        left: 100px;
        cursor: pointer;
        z-index: 100;
        border: 1px solid red;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/preview.vue